import { render, staticRenderFns } from "./Ellipsis.vue?vue&type=template&id=17fd294d&scoped=true"
import script from "./Ellipsis.vue?vue&type=script&lang=js"
export * from "./Ellipsis.vue?vue&type=script&lang=js"
import style0 from "./Ellipsis.vue?vue&type=style&index=0&id=17fd294d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17fd294d",
  null
  
)

export default component.exports